import _ from 'lodash-es';
import template from './value-builder.html';

const valueBuilderDirective = /* @ngInject */ () => ({
	scope: {
		data: '=',
		label: '@',
		tooltipText: '@',
		valueLabel: '@',
		labelLabel: '@',
		valueProperty: '@',
		labelProperty: '@',
	},
	restrict: 'E',
	template,
	replace: true,
	/**
	 * @param {any} $scope
	 * @param {any} element
	 * @param {any} attributes
	 */
	link($scope, element, attributes) {
		$scope.valueProperty = $scope.valueProperty || 'value';
		$scope.labelProperty = $scope.labelProperty || 'label';
		$scope.valueLabel = $scope.valueLabel || 'Value';
		$scope.labelLabel = $scope.labelLabel || 'Label';
		$scope.data = $scope.data || [];

		$scope.addValue = () => {
			/** @type {any} */
			const object = {};
			object[$scope.valueProperty] = '';
			object[$scope.labelProperty] = '';
			$scope.data.push(object);
		};

		$scope.removeValue = (/** @type {number} */ index) => {
			$scope.data.splice(index, 1);
		};

		if ($scope.data.length === 0) {
			$scope.addValue();
		}

		if (!attributes.noAutocompleteValue) {
			$scope.$watch('data', (/** @type {any[]} */ newValue, /** @type {any[]} */ oldValue) => {
				// Ignore array addition/deletion changes
				if (newValue.length !== oldValue.length) {
					return;
				}

				_.map(newValue, (entry, index) => {
					if (
						entry[$scope.labelProperty] !== oldValue[index][$scope.labelProperty] // label changed
						&& (
							entry[$scope.valueProperty] === ''
							|| entry[$scope.valueProperty] === _.camelCase(oldValue[index][$scope.labelProperty])
						)
					) {
						entry[$scope.valueProperty] = _.camelCase(entry[$scope.labelProperty]);
					}
				});
			}, true);
		}
	},
});

export default valueBuilderDirective;
